/**
 * Created by ivo on 02.11.14.
 */


define([
    'common',
    'jQuery',
    './widgetFactory',
    'library/fcse-request/multiRequestHandler',
    'library/fcse-state/Scope',
    'library/fcse-visibilitycontrol/visibilityControl',
], function (common, $, WidgetFactory, MultiRequestHandler, Scope, VisibilityControl) {
    // Create scopes
    var rootScope = new Scope();
    var localScope = new Scope(rootScope);

    // Create widget factory
    var widgetFactory = new WidgetFactory({rootScope: rootScope, localScope: localScope});

    // Initialize Multirequest-Handler
    var requestHandler = new MultiRequestHandler();

    // Add VisibilityControl
    var visibilityControl = new VisibilityControl('[data-fcse-role="visibility-control"]', {
        'targetIsVisibleClass': 'is-active',
        'targetIsHiddenClass': 'is-collapsed'
    });
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/pages/exception/error404.js